import 'twin.macro';
import React from 'react';
import useBos from '@teetsh/app/src/queries/bo/useBos';
import Select from '@teetsh/app/src/components/Form/Select2';

interface Props {
  minimal?: boolean;
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
}

export function BoListLarge(props: Props) {
  const { disabled } = props;
  const { data } = useBos();
  const boList = data || [];

  const options = boList.map(b => ({
    value: b.id,
    label: b.name,
  }));

  return (
    <Select<string>
      options={options}
      value={props.value}
      onChange={props.onChange}
      disabled={disabled}
      large
    />
  );
}
